import React from "react";

function FilterBar({ activeFilter, setActiveFilter, areaQuery, setAreaQuery }) {

    const buttons = [
        { label: "All", value: "all" },
        { label: "On-Demand Print", value: "printShop" },
        { label: "Specialist Print", value: "specialist" },
        { label: "Print Suppliers", value: "supplier" },
    ];

    return (
        <div className="flex flex-wrap items-center gap-[8px] pb-[2px]">

            {/* Filter Buttons */}
            {buttons.map((btn) => (
                <button
                    key={btn.value}
                    onClick={() => setActiveFilter(btn.value)}
                    className={`px-[16px] py-[8px] rounded-[10px] font-semibold text-[13px] whitespace-nowrap transition-all
                        ${activeFilter === btn.value
                            ? "bg-[#ff5323] text-white"
                            : "border border-[#e4e5e7] text-[#212326] hover:bg-[#f4f5f6]"
                        }`}
                >
                    {btn.label}
                </button>
            ))}

            {/* Divider */}
            <div className="h-[24px] w-[1px] bg-[#e4e5e7] mx-[4px] hidden sm:block" />

            {/* Area Search */}
            <div className="relative">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="absolute left-[12px] top-1/2 -translate-y-1/2 w-[14px] h-[14px] pointer-events-none text-[#9298a0]"
                >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                </svg>

                <input
                    type="text"
                    placeholder="Search area..."
                    value={areaQuery}
                    onChange={(e) => setAreaQuery(e.target.value)}
                    className="h-[36px] w-[200px] pl-[34px] pr-[12px] rounded-[10px] font-semibold text-[16px] transition-all bg-white border border-[#e4e5e7] text-[#212326] placeholder:text-[#9298a0] hover:bg-[#f4f5f6] focus:outline-none focus:border-[#ff5323]"
                />
            </div>
        </div>
    );
}

export default FilterBar;